import React, { useEffect, useState, useRef } from 'react'
import { useImmer } from 'use-immer'
import { useDispatch, useSelector } from 'react-redux'

import Button from 'components/common/Button'
import {
    getTechnologies,
    filterTechnologies,
    getTechnologyStats,
    resetTechnologyBrowserState,
} from 'store/technologies/actions'
import Image from 'components/common/ImageLoader'
import { useMediaQueryUtils } from 'constants/exportHooks'
import SearchIcon from 'assets/search_icon_old.svg'
import queryString from 'query-string'

const FilterTechnologies = ({ updateFilterQueryParams }) => {
    const { filter_fields, filter_values, search } = queryString.parse(
        window.location.search
    )
    const stats = useSelector(
        (state) => state.technologyBrowserState?.stats?.data
    )
    const { isDesktop, isMobile, isTablet } = useMediaQueryUtils()
    const dispatch = useDispatch()

    const [state, setState] = useImmer({
        filterQueryParams: {
            field: filter_fields,
            value: filter_values,
        },
        lastFilter: '',
    })

    useEffect(() => {
        if (search) {
            searchInputRef.current.value = search
        }
    }, [])

    const { filterQueryParams, lastFilter } = state

    const searchInputRef = useRef('')

    // check if filter query params state changed, if yes then
    useEffect(() => {
        if (Object.keys(filterQueryParams).length > 0) {
            // updateFilterQueryParams(
            //     filterQueryParams.field,
            //     filterQueryParams.value
            // )
            executeFilterQuery()
        }
    }, [filterQueryParams])

    // filter query (for tags or vendors)
    const executeFilterQuery = () => {
        console.log('from filter technologies execute query')
        dispatch(getTechnologies(window.location.search))
    }

    // search query
    const executeSearchQuery = () => {
        const { filter_fields, filter_values } = queryString.parse(
            window.location.search
        )
        const filterQuery = queryString.stringify({
            filter_fields,
            filter_values,
        })
        const urlQueryString = `?search=${searchInputRef.current.value}${
            filterQuery ? `&${filterQuery}` : ''
        }`
        if (
            searchInputRef.current.value !== null &&
            searchInputRef.current.value.length > 0
        ) {
            window.history.pushState({}, document.title, urlQueryString)
            dispatch(getTechnologies(urlQueryString))
        }
    }

    const onClickFilter = (field, value) => {
        const { search } = queryString.parse(window.location.search)
        const searchQuery = queryString.stringify({
            search,
        })
        if (
            Object.keys(filterQueryParams).length > 0 &&
            filterQueryParams?.field === field &&
            filterQueryParams?.value === value
        ) {
            window.history.pushState(
                {},
                document.title,
                `${searchQuery ? `?${searchQuery}` : '?'}`
            )
            setState((draft) => {
                draft.filterQueryParams = {}
            })
            dispatch(getTechnologies(window.location.search))
        } else {
            window.history.pushState(
                {},
                document.title,
                `?filter_fields=${field}&filter_values=${value}${
                    searchQuery ? `&${searchQuery}` : ''
                }`
            )
            setState((draft) => {
                draft.filterQueryParams = {
                    field,
                    value,
                }
            })
        }
    }

    // Reset action on results
    const resetSearchResults = () => {
        // clear search query params from frontend URL
        window.history.pushState({}, document.title, '/technologies')

        dispatch(getTechnologies())
    }

    const clearFilter = () => {
        searchInputRef.current.value = ''
        setState((draft) => {
            draft.filterQueryParams = {}
        })
        window.history.pushState({}, document.title, '?')
        dispatch(getTechnologies())
        // updateFilterQueryParams()
    }

    return (
        <React.Fragment>
            <div className="h-full">
                <div className="">
                    <div className="flex justify-between items-center ">
                        <div className="text-lg font-semibold">Filters</div>
                        <a
                            className="p-v-1 px-2 bg-negative-red-100 text-md-label rounded-md text-negative-red-600 font-semibold"
                            href=""
                            onClick={(e) => {
                                e.preventDefault()
                                clearFilter()
                            }}
                        >
                            Clear
                        </a>
                    </div>

                    <div className="w-full py-2 flex items-center">
                        <div
                            id="search-fingerprint-box"
                            className="py-2 relative flex flex-wrap items-center w-full"
                        >
                            <input
                                className="px-4 text-sm pr-10 py-2 rounded-sm sm:w-11/12 border border-gray-300 focus:outline-none  "
                                type="text"
                                placeholder="Search "
                                ref={searchInputRef}
                                onKeyUp={(e) => {
                                    if (e.keyCode == 13) {
                                        executeSearchQuery()
                                    }
                                }}
                            />

                            <div className="sm:-ml-10 xl:-ml-12">
                                <Image
                                    addClass=""
                                    src={SearchIcon}
                                    width={isTablet || isMobile ? '25' : '35'}
                                    height={isTablet || isMobile ? '25' : '35'}
                                />
                            </div>
                        </div>
                        <div className="py-2 ml-2">
                            <Button
                                customClass="px-3 py-1 rounded bg-primary-purple-500 text-sm"
                                onClick={executeSearchQuery}
                            >
                                Search
                            </Button>
                        </div>
                    </div>

                    <div className="px-2 py-2 ">
                        <div className="py-3">Tags</div>
                        <div
                            className="overflow-y-auto"
                            style={{ maxHeight: 180 }}
                        >
                            {stats?.count_by_tags &&
                                Object.keys(stats?.count_by_tags).map(
                                    (item, index) => (
                                        <React.Fragment key={index}>
                                            <div
                                                onClick={(e) => {
                                                    e.preventDefault()
                                                    onClickFilter('tags', item)
                                                }}
                                                className="w-full flex flex-wrap py-1 cursor-pointer"
                                            >
                                                <div className="w-1/12 ">
                                                    <input
                                                        type="radio"
                                                        name="category"
                                                        checked={
                                                            filterQueryParams.value ===
                                                            item
                                                        }
                                                    />
                                                </div>
                                                <div className="w-11/12 pl-2 text-sm">
                                                    {item}
                                                    <span class="pl-1 text-sm ">
                                                        (
                                                        {
                                                            stats.count_by_tags[
                                                                item
                                                            ]
                                                        }
                                                        )
                                                    </span>
                                                </div>
                                            </div>
                                        </React.Fragment>
                                    )
                                )}
                        </div>
                    </div>
                    <div className="px-2 py-2 ">
                        <div className="py-3">Vendors</div>
                        <div
                            className="overflow-y-auto"
                            style={{ maxHeight: 180 }}
                        >
                            {stats?.count_by_vendor &&
                                Object.keys(stats?.count_by_vendor)
                                    .reverse()
                                    .map((item, index) => (
                                        <React.Fragment key={index}>
                                            <div
                                                onClick={(e) => {
                                                    e.preventDefault()
                                                    onClickFilter(
                                                        'vendor',
                                                        item
                                                    )
                                                }}
                                                className="w-full flex flex-wrap py-1 cursor-pointer"
                                            >
                                                <div className="w-1/12 ">
                                                    <input
                                                        type="radio"
                                                        name="category"
                                                        checked={
                                                            filterQueryParams.value ===
                                                            item
                                                        }
                                                    />
                                                </div>
                                                <div className="w-11/12 pl-2 text-sm">
                                                    {item}
                                                    <span class="pl-1 text-sm ">
                                                        (
                                                        {
                                                            stats
                                                                .count_by_vendor[
                                                                item
                                                            ]
                                                        }
                                                        )
                                                    </span>
                                                </div>
                                            </div>
                                        </React.Fragment>
                                    ))}
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

export default FilterTechnologies
